import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Download, Play } from 'lucide-react';
function EbookGraphic() {
  return <div className="relative w-full h-48 md:h-56 mb-8 overflow-hidden rounded-2xl shadow-warm" data-id="element-1307">
      <img src="https://cdn.magicpatterns.com/uploads/7PVX1WqpPR4P9M1pET7Qmc/ebook_9_pasi_abundenta.png" alt="E-book: 9 Pași prin care să aduci Abundența în viața ta" className="absolute inset-0 w-full h-full object-cover" data-id="element-1308" />
    </div>;
}
function WorkshopGraphic() {
  return <div className="relative w-full h-48 md:h-56 mb-8 overflow-hidden rounded-2xl shadow-warm" data-id="element-1309">
      <img src="https://cdn.magicpatterns.com/uploads/bsM7kwZNCzU1TaxaK9H5By/workshop_bani_constientizare.png" alt="Workshop online Heal Your Life: Bani și Conștientizare" className="absolute inset-0 w-full h-full object-cover" data-id="element-1310" />
    </div>;
}
export function FreeResourcesSection() {
  return <section id="resurse" className="py-20 lg:py-32 bg-[#F8F3ED] relative overflow-hidden" data-id="element-1311">
      {/* Subtle decorative elements */}
      <div className="absolute top-0 left-0 w-[50%] h-[50%] bg-gradient-to-br from-brand-purple/[0.03] to-transparent rounded-br-full pointer-events-none" data-id="element-1312" />
      <div className="absolute bottom-0 right-0 w-[45%] h-[45%] bg-gradient-to-tl from-brand-gold/[0.05] to-transparent rounded-tl-full pointer-events-none" data-id="element-1313" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-1314">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 lg:mb-24" data-id="element-1315">
          <div className="inline-block mb-4" data-id="element-1316">
            <span className="font-heading font-bold text-xs md:text-sm tracking-[0.15em] text-brand-purple uppercase" data-id="element-1317">
              Resurse Gratuite
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-text mb-6" data-id="element-1318">
            Cadourile mele pentru tine
          </h2>
          <div className="h-[2px] w-16 bg-brand-gold mx-auto rounded-full" data-id="element-1319" />
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-1320">
          {/* E-book Card */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-3xl p-8 lg:p-10 shadow-warm hover:shadow-warm-hover transition-all duration-300 flex flex-col border border-brand-gold/10 group" data-id="element-1321">
            <EbookGraphic data-id="element-1322" />

            <h3 className="font-heading font-bold text-2xl text-brand-text mb-4" data-id="element-1323">
              E-book: 9 Pași prin care să aduci Abundența în viața ta
            </h3>

            <p className="text-brand-textSec leading-relaxed mb-6" data-id="element-1324">
              Primești acces gratuit la un ghid practic care te ajută să îți
              schimbi mentalitatea despre bani și succes, să capeti claritate
              asupra obiectivelor tale și să începi transformarea chiar de acum.
            </p>

            <div className="mb-8" data-id="element-1325">
              <p className="font-semibold text-brand-text mb-3" data-id="element-1326">
                Ce vei descoperi în e-book:
              </p>
              <ul className="space-y-2" data-id="element-1327">
                {['Cum să îți schimbi mentalitatea despre bani', 'Cum să îți clarifici obiectivele de abundență', 'Tehnici practice de reprogramare a subconștientului', 'Pași concreți pentru a atrage prosperitatea', 'Exerciții zilnice pentru o viață plină de armonie'].map((item, i) => <li key={i} className="flex items-center gap-2 text-lg text-brand-textSec" data-id="element-1328">
                    <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-1329" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <a href="https://drive.google.com/file/d/15jKiEVk9c9nvvceERb9C7S4nZV9aO_-m/view?usp=sharing" target="_top" className="inline-flex items-center justify-center gap-3 bg-brand-gold text-brand-cream font-heading font-semibold px-8 py-4 rounded-xl hover:bg-brand-purple transition-colors duration-300 shadow-warm text-center mt-auto" data-id="element-1330">
              <Download className="w-5 h-5" data-id="element-1331" />
              Primește E-book-ul Gratuit
            </a>
          </motion.div>

          {/* Workshop Card */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-3xl p-8 lg:p-10 shadow-warm hover:shadow-warm-hover transition-all duration-300 flex flex-col border border-brand-purple/10 group relative overflow-hidden" data-id="element-1332">
            <WorkshopGraphic data-id="element-1333" />

            <h3 className="font-heading font-bold text-2xl text-brand-text mb-4 relative z-10" data-id="element-1334">
              Workshop online Heal Your Life "Bani și Conștientizare"
            </h3>

            <p className="text-brand-textSec leading-relaxed mb-6 relative z-10" data-id="element-1335">
              Vrei sa atingi un nou nivel de Prosperitate în viața ta? Vrei sa
              intelegi rolul pe care-l are conștientizarea ta în relație cu
              banii? Vrei să atragi mai mulți bani în viața ta? Atunci acest
              workshop este pentru tine.
            </p>

            <div className="mb-6 relative z-10" data-id="element-1336">
              <p className="font-semibold text-brand-text mb-3" data-id="element-1337">
                Din temele workshopului:
              </p>
              <ul className="space-y-2" data-id="element-1338">
                {['Convingeri despre bani', 'Principii Universale', 'Crearea Noii Realități', 'Dezvoltarea Încrederii', 'Intenții de Prosperitate'].map((item, i) => <li key={i} className="flex items-center gap-2 text-lg text-brand-textSec" data-id="element-1339">
                    <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-1340" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex items-center gap-4 mb-8 relative z-10" data-id="element-1341">
              <div className="flex flex-col" data-id="element-1342">
                <span className="text-lg text-brand-textSec line-through" data-id="element-1343">
                  Cost real: 333 lei
                </span>
                <span className="font-bold text-brand-coral text-lg" data-id="element-1344">
                  Acum gratuit
                </span>
              </div>
              <div className="w-px h-10 bg-brand-gold/20 mx-2" data-id="element-1345" />
              <div className="text-lg text-brand-textSec" data-id="element-1346">
                Durata 3h
                <br data-id="element-1347" />
                online zoom
              </div>
            </div>

            <a href="https://academiadeabundenta.ro/resurse-gratuite" target="_top" className="inline-flex items-center justify-center gap-3 bg-brand-gold text-brand-cream font-heading font-semibold px-8 py-4 rounded-xl hover:bg-brand-purple transition-colors duration-300 shadow-warm text-center mt-auto relative z-10" data-id="element-1348">
              <Play className="w-5 h-5" data-id="element-1349" />
              Participă Gratuit la Workshop
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}